import '../../../../App.css';
import ProjectsList from "./ProjectList";
import ProjectAdd from "./ProjectAdd";


const Projects = () => {
    return (
        <div className="Projects">
            <h1>Projects</h1>
            <ProjectAdd />
            <ProjectsList />
        </div>
    );
};
export default Projects;
